var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"unicode-bidi":"bidi-override !important"},attrs:{"id":"app","dir":_vm.direction}},[(_vm.$auth.check() && _vm.$auth.token())?_c('WebLayout',{key:_vm.incrementer},[_c('template',{slot:"layout"},[_c('router-view',{key:_vm.$route.fullPath})],1)],2):_c('router-view',{key:_vm.$route.fullPath})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07f76434","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 